import { Ad, layoutName, layoutNameShort } from "@/extensions/obituary/types";

function adName(ad: Ad, variant: "short" | "long" = "short") {
  const name = ad.publication.name;
  const layout =
    variant === "short"
      ? layoutNameShort[ad.layout_variant]
      : layoutName[ad.layout_variant];

  return `${name}, ${layout}`;
}

export default adName;
